var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPride(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi_3022494",
    enableBackground: "new 0 0 512.048 512.048",
    height: 512,
    viewBox: "0 0 512.048 512.048",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m484.357 283.152v-15.052c0-60.99-23.751-118.329-66.877-161.456s-100.466-66.877-161.456-66.877l-10.667 15 10.667 206.802 198.357 21.583z",
    fill: "#ff3a3b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.024 39.767c-60.99 0-118.329 23.751-161.455 66.877-43.127 43.126-66.878 100.466-66.878 161.456v15.034h30.024l198.31-21.565z",
    fill: "#ff5645"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.024 69.767-10.667 17 10.667 174.803 168.333 21.643h30v-15.113c0-109.361-88.972-198.333-198.333-198.333z",
    fill: "#fd8c02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.691 268.1v15.112h30l168.333-21.643v-191.802c-109.361 0-198.333 88.972-198.333 198.333z",
    fill: "#fdb902"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.024 99.767-10.667 19 10.667 142.802 138.333 21.643h30v-15.112c0-92.819-75.514-168.333-168.333-168.333z",
    fill: "#fdb902"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.691 268.1v15.112h30l138.333-21.643v-161.802c-92.82 0-168.333 75.514-168.333 168.333z",
    fill: "#fdd902"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.024 129.767-10.667 10.333 10.667 121.469 108.333 21.643h30v-15.112c0-76.277-62.056-138.333-138.333-138.333z",
    fill: "#0dca71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.691 268.1v15.112h30l108.333-21.643v-131.802c-76.277 0-138.333 62.056-138.333 138.333z",
    fill: "#04db7b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.024 159.767-10.667 12.333 10.667 89.469 78.333 21.643h30v-15.112c0-59.735-48.598-108.333-108.333-108.333z",
    fill: "#8cc6fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.691 268.1v15.112h30l78.333-21.643v-101.802c-59.735 0-108.333 48.598-108.333 108.333z",
    fill: "#a4d2fe"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.024 189.767-10.667 90 10.667 3.445h78.333v-15.112c0-43.193-35.14-78.333-78.333-78.333z",
    fill: "#7f66ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.691 268.1v15.112h78.333v-93.445c-43.193 0-78.333 35.14-78.333 78.333z",
    fill: "#a079ff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512.048 347.521v-30h-80.604v150.096h80.604v-30h-50.604v-30.048h46.873v-30h-46.873v-30.048z",
    fill: "#6862ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.574 466.434-.321-147.674h48.34c37.381 0 62.497 29.662 62.497 73.809 0 19.303-5.559 37.189-15.653 50.363-11.211 14.632-27.408 22.866-45.607 23.184-9.494.166-49.256.318-49.256.318zm29.734-117.673.161 87.54s14.504-.104 18.837-.179c21.956-.384 31.784-22.15 31.784-43.552 0-13.221-3.206-24.79-9.026-32.576-5.649-7.558-13.327-11.232-23.471-11.232h-18.285z",
    fill: "#8cc6fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.481 452.461-39.06-44.38c20.03-5.665 34.702-23.515 34.702-44.614 0-25.64-21.659-46.499-48.282-46.499h-47.246-.011l.011 151.202h30v-49.707l47.367 53.818zm-52.639-105.493c9.91 0 18.282 7.556 18.282 16.499s-8.372 16.499-18.282 16.499c-3.972 0-17.068.058-17.068.058l-.094-33.056z",
    fill: "#fdd902"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.795 316.968h-48.747-.048l.048 151.202h30v-52.727c6.846-.035 14.422-.068 18.748-.068 27.5 0 49.873-22.072 49.873-49.203-.001-27.132-22.373-49.204-49.874-49.204zm0 68.406c-4.311 0-11.788.032-18.595.067-.035-7.048-.088-31.111-.108-38.473h18.703c10.772 0 19.873 8.794 19.873 19.203s-9.1 19.203-19.873 19.203z",
    fill: "#ff5645"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m271.048 316.968h-15l-3.82 80.128 3.82 71.074h15z",
    fill: "#0dca71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.048 316.968h15v151.202h-15z",
    fill: "#04db7b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPride);
export default __webpack_public_path__ + "static/media/pride.9b521a29ec575b80110ee409a7b1a730.svg";
export { ForwardRef as ReactComponent };